<template>
  <v-card
    class="dialog-card"
    style="padding-bottom: 20px">
    <div class="modal-container">
      <!-- Header Start -->
      <ModalHeader
        icon="mdi-information"
        modalTitle="Information"
        @close="onClose()" />
      <!-- Header End -->
      <MDXContainer :comp="helpComponents[mdxName]" />
    </div>
  </v-card>
</template>
<script setup>
import { helpComponents } from './utils/doc-components';
import MDXContainer from './MDXContainer.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';

const props = defineProps(['mdxName']);

const emit = defineEmits(['close']);

function onClose() {
  emit('close', true);
}
</script>
<style scoped></style>
